import { render, staticRenderFns } from "./TeamShiftRotaEdit.vue?vue&type=template&id=7a2099a5&"
import script from "./TeamShiftRotaEdit.vue?vue&type=script&lang=js&"
export * from "./TeamShiftRotaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports